function Footer() {
  return (
    <div className="h-12 border-t">
      <div className="max-w-7xl px-8"></div>
    </div>
  );
}

export default Footer;
